import InternalTransportBaseScreen from "../../../../mapping_tool/UpdateNodes/shared/internalTransport/InternalTransportBaseScreen";

export const ProcessInternalTransportBase = ({ modalData }: { modalData: any }) => (
  <InternalTransportBaseScreen modalData={modalData} gate="process" variant="simulate" />
);
